import React, { useEffect, useState } from "react";
import "./styles.css";

import AnimateHeight from "react-animate-height";
import { NavLink, useLocation } from "react-router-dom";
import { FiChevronDown, FiCircle } from "react-icons/fi";
import { CardSidebar, CardSidebarProps } from "../CardSidebar";

interface CardSubItemSidebarProps {
  title: string;
  path?: string;
  subItens: CardSidebarProps[];
  onNavigate?: () => void;
  level?: number;
}

const hasActiveRoute = (items: CardSidebarProps[] | undefined, pathname: string): boolean => {
  if (!items?.length) return false;

  return items.some((item) => {
    if (item.path && pathname.startsWith(item.path)) return true;
    return hasActiveRoute(item.itens || item.subItens, pathname);
  });
};

export const CardSubItemSidebar = ({
  title,
  subItens,
  path,
  onNavigate,
  level = 1,
}: CardSubItemSidebarProps) => {
  const location = useLocation();
  const childIsActive = hasActiveRoute(subItens, location.pathname);
  const linkIsActive = Boolean(path && location.pathname.startsWith(path));
  const isActive = linkIsActive || childIsActive;
  const [subItensOpen, setSubItensOpen] = useState<boolean>(isActive);

  useEffect(() => {
    if (isActive) {
      setSubItensOpen(true);
    }
  }, [isActive]);

  const itemClassName = `sidebar-nav-link sidebar-subitem-toggle level-${level} ${isActive ? "active" : ""}`;

  return (
    <li className="sidebar-nav-item">
      {path ? (
        <NavLink
          to={path}
          className={({ isActive: navLinkActive }) =>
            `${itemClassName} ${navLinkActive ? "active" : ""}`
          }
          onClick={onNavigate}
        >
          <span className="sidebar-nav-icon sidebar-nav-dot" aria-hidden="true"><FiCircle /></span>
          <span className="sidebar-nav-label">{title}</span>
          <FiChevronDown className="sidebar-nav-chevron" aria-hidden="true" />
        </NavLink>
      ) : (
        <button
          className={`${itemClassName} ${subItensOpen ? "open" : ""}`}
          type="button"
          aria-expanded={subItensOpen}
          onClick={() => setSubItensOpen(!subItensOpen)}
        >
          <span className="sidebar-nav-icon sidebar-nav-dot" aria-hidden="true"><FiCircle /></span>
          <span className="sidebar-nav-label">{title}</span>
          <FiChevronDown className="sidebar-nav-chevron" aria-hidden="true" />
        </button>
      )}

      <AnimateHeight duration={240} height={subItensOpen ? "auto" : 0}>
        <ul className="sidebar-nav-children">
          {subItens.map((item) => (
            <CardSidebar
              key={`${item.title}-${item.path || "group"}`}
              title={item.title}
              path={item.path}
              itens={item.itens}
              level={level + 1}
              onNavigate={onNavigate}
            />
          ))}
        </ul>
      </AnimateHeight>
    </li>
  );
};
